if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
    $('body').addClass('loaded');
    setTimeout(function() {
        $('body').removeClass('loaded');
        $('#loader-wrapper').addClass('loaded');
    }, 1000);

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $('.slider-cards__sliders').slick({
        accessibility: false,
        asNavFor: '.slider-cards__sliderp',
        arrows:false,
        slidesToScroll:1 ,
        slidesToScroll:1 ,
        variableWidth: false,
        fade:true
    });


    $('.slider-cards__sliderp').on('init', function(event, slick) {
    }).slick({
        accessibility: false,
    }).on('afterChange', function(event, slick, currentSlide){
        $('.slider-cards__circle')
            .html(`
            <div class="progess-svg-holder">
            <svg class="progress-svg" width="85" height="85">
            <g transform="translate(42,40)">
            <circle class="circle-go" r="40" cx="0" cy="0"></circle>
            </g> 
            </svg>
            </div>`);
    }).trigger('afterChange');


    $('.slider-news-js').on('init', function(event, slick) {
    }).slick({
        accessibility: false,
        
    }).on('afterChange', function(event, slick, currentSlide){
        $('.slider-news__circle')
            .html(`
            <div class="progess-svg-holder">
            <svg class="progress-svg" width="85" height="85">
            <g transform="translate(42,40)">
            <circle class="circle-go" r="40" cx="0" cy="0"></circle>
            </g> 
            </svg>
            </div>`);
    }).trigger('afterChange');


    $('.sym-slides').slick({
        accessibility: false,
    });


    $('.tab-quad__filter ul li').click(function(){
        const thisTag = $(this).attr('data-tag');
        $('.tab-quad--filter .tab-quad__item').hide();
        $('.tab-quad--filter .'+thisTag).fadeIn();
        $('.tab-quad__filter ul li').removeClass('active');
        $(this).addClass('active');
    })
    $('.tab-quad__filter ul li').eq(0).click();

})();